import { connect } from "react-redux";

// Modules
import { MapViewBase } from "./MapViewBase";
import Render from "./MapViewRender";

// Components
import withNotifications from "../withNotifications";

class MapView extends MapViewBase {
  render() {
    return Render.call(this, this.props, this.state);
  }
}

const mapStateToProps = state => ({
  user: state.user || {},
  buyers: state.buyers || []
});

export default connect(mapStateToProps)(withNotifications(MapView));
